// @flow
import { combineReducers } from 'redux';
import type { PhoneLinesActionType } from './actions';

export type PhoneLinesEditingStateType = {
  data: Object[],
  editing: boolean,
};

const editing = (state: boolean = false, action: PhoneLinesActionType) => {
  switch (action.type) {
    case 'TOGGLE_PHONE_LINES_EDITING':
      return !state;
    default:
      return state;
  }
};

const data = (state: Object[] = [], action: PhoneLinesActionType) => {
  switch (action.type) {
    case 'FETCH_PHONE_LINES_SUCCESS':
      return action.payload.phoneLines;
    case 'UPDATE_PHONE_LINE_ALIAS': {
      const { alias, number } = action.payload;

      return state.map(line => {
        if (line.number !== number) {
          return line;
        }
        return { ...line, alias };
      });
    }
    default:
      return state;
  }
};

export const phoneLinesEditingReducer = combineReducers({
  data,
  editing,
});
